import { render, staticRenderFns } from "./Pro_menu.vue?vue&type=template&id=4d352c9e&scoped=true&"
import script from "./Pro_menu.vue?vue&type=script&lang=js&"
export * from "./Pro_menu.vue?vue&type=script&lang=js&"
import style0 from "./Pro_menu.vue?vue&type=style&index=0&id=4d352c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d352c9e",
  null
  
)

export default component.exports